import { useEffect, useState } from "react";
import api from "../../api/axiosInstance";
const Profile = () => {
  const [user, setUser] = useState({});
  useEffect(() => {
    var userId = localStorage.getItem("uTsReD");
    var config = {
      method: "get",
      url: process.env.REACT_APP_API_URL + "Users/GetUser/" + userId,
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": process.env.REACT_APP_Host,
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      },
    };

    api(config).then(function (response) {
      if (response.data.statusCode === 200) {
        setUser(response.data.content);
      }
    });
  }, []);
  return (
    <>
      <div className="container-fluid ">
        <div className="row">
          <div className="col-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
            <h3 className="mb-20">Welcome, {user.firstName} {user.lastName}</h3>
            <div className="row">
                <div className="col-md-4">
                    <div className="card">
                        <div className="card-body">
                            <div className="row justify-content-center mb-3">
                                <div className="col-12 col-md-3 col-lg-3">
                                    <h5 className="text-right">First Name</h5>
                                </div>
                                <div className="col-12 col-md-6 col-lg-6">
                                    <input className="form-control form-control-sm" value={user.firstName}/>
                                </div>
                            </div>
                            <div className="row justify-content-center mb-3">
                                <div className="col-12 col-md-3 col-lg-3">
                                    <h5 className="text-right">Last Name</h5>
                                </div>
                                <div className="col-12 col-md-6 col-lg-6">
                                    <input className="form-control form-control-sm" value={user.lastName}/>
                                </div>
                            </div>
                            <div className="row justify-content-center mb-3">
                                <div className="col-12 col-md-3 col-lg-3">
                                    <h5 className="text-right">Email</h5>
                                </div>
                                <div className="col-12 col-md-6 col-lg-6">
                                    <input className="form-control form-control-sm" value={user.email}/>
                                </div>
                            </div>
                            <div className="row justify-content-center mb-3">
                                <div className="col-12 col-md-3 col-lg-3">
                                    <h5 className="text-right">Role</h5>
                                </div>
                                <div className="col-12 col-md-6 col-lg-6">
                                    <input className="form-control form-control-sm" value={user.roleName}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Profile;
